$(document).ready(function() {
  var $h2s = $(".blog-post-content h2").filter(function() {
    return $.trim($(this).text()).length > 0;
  });
  var $lists = $(".pcs--list ul");
  var $blocks = $(".post-contents--sidebar");

  if (!$h2s.length) {
    $blocks.remove();
  } else if ($lists.length) {
    $lists.empty();

    $h2s.each(function(index) {
      var $h2 = $(this);
      var id = $h2.attr("id") || "heading-" + (index + 1);
      $h2.attr("id", id);

      $lists.each(function() {
        var $li = $("<li></li>");
        var $a = $("<a></a>").attr("href", "#" + id).text($.trim($h2.text()));
        var $svg = $(`
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.8125 9H15.1875" stroke="#DC0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.125 3.9375L15.1875 9L10.125 14.0625" stroke="#DC0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `);
        $a.prepend($svg);
        $li.append($a);
        $(this).append($li);
      });
    });

    $lists.find("a").on("click", function(e) {
      e.preventDefault();
      var $target = $(document.getElementById($(this).attr("href").substring(1)));

      if ($target.length) {
        var offset = 80;
        var scrollPos = $target.offset().top - offset;

        $("html, body").animate({ scrollTop: scrollPos }, 500);
      }
    });
  }

  var sidebar = document.querySelector('.blog-side--bar__inner');
  var mainContent = document.querySelector('.post-content--main');
  var offsetTop = 100;

  if (!sidebar || !mainContent) return;

  var sidebarInitial = sidebar.getBoundingClientRect().top + window.scrollY;
  var sidebarHeight = sidebar.offsetHeight;
  var mainHeight = mainContent.offsetHeight;
  var sidebarWidth = sidebar.offsetWidth;

  function handleSticky() {
    var scrollY = window.scrollY;

    if (scrollY + offsetTop > sidebarInitial && scrollY + offsetTop + sidebarHeight < sidebarInitial + mainHeight) {
      sidebar.style.position = 'fixed';
      sidebar.style.top = offsetTop + 'px';
      sidebar.style.width = sidebarWidth + 'px';
    } else if (scrollY + offsetTop + sidebarHeight >= sidebarInitial + mainHeight) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = (mainHeight - sidebarHeight) + 'px';
      sidebar.style.width = sidebarWidth + 'px';
    } else {
      sidebar.style.position = 'static';
      sidebar.style.top = 'auto';
      sidebar.style.width = 'auto';
    }
  }

  function updateSizes() {
    sidebarInitial = sidebar.getBoundingClientRect().top + window.scrollY;
    sidebarHeight = sidebar.offsetHeight;
    mainHeight = mainContent.offsetHeight;
  }

  window.addEventListener('scroll', handleSticky);
  window.addEventListener('resize', function () {
    updateSizes();
    handleSticky();
  });
});
